import { EMemberChoicesLabels } from 'affiny-core/modules/api/models/memberchoice/memberchoice.types';
import { getAnswerFromLabel } from 'affiny-core/modules/helpers/informationList';
import { TPartialAnswerLabels } from 'affiny-core/modules/memberchoices/types';
import { IRootState } from 'affiny-core/modules/state';
import { selectMemberChoiceAnswerLabelsByLabels } from '../memberChoicesSelectors';

export const selectHobbies = (
  state: IRootState,
  memberAnswers: TPartialAnswerLabels
) => {
  const myAnswers = selectMemberChoiceAnswerLabelsByLabels(state, [
    EMemberChoicesLabels.profileHobbies,
    EMemberChoicesLabels.profileSports,
  ]);

  const memberHobbies = getAnswerFromLabel(
    memberAnswers,
    EMemberChoicesLabels.profileHobbies
  );
  const memberSports = getAnswerFromLabel(
    memberAnswers,
    EMemberChoicesLabels.profileSports
  );
  const myHobbies = getAnswerFromLabel(
    myAnswers,
    EMemberChoicesLabels.profileHobbies
  );
  const mySports = getAnswerFromLabel(
    myAnswers,
    EMemberChoicesLabels.profileSports
  );

  return {
    values: formatCommonAnswers(memberHobbies, myHobbies),
    sports: formatCommonAnswers(memberSports, mySports),
  };
};

const formatCommonAnswers = (memberAnswers?: string[], myAnswers?: string[]) =>
  memberAnswers
    ? memberAnswers.map(label => ({
        label,
        isInCommon: myAnswers ? myAnswers.includes(label) : false,
      }))
    : undefined;

export type IHobbies = ReturnType<typeof selectHobbies>;
